<template lang="pug">
v-expansion-panel-content
  v-layout(align-center, justify-space-between, slot='header')
    div
      transition(name='fade', mode='out-in')
        v-icon.mr-3(v-if='data.enabled' color='green', key='enabled') fa fa-check
        v-icon.mr-3(v-else, key='disabled') fa fa-ban

      span SMS bericht naar {{ isDealer ? 'dealer' : 'klant' }}

    PersonalisationPricingDialog

  v-layout(justify-start, align-center)
    v-layout.ml-4.mt-4(column)
      b Wil je dat de {{ isDealer ? 'dealer' : 'klant' }} een SMS notificatie ontvangt?
      v-switch(
        :label='data.enabled ? "Ingeschakeld" : "Uitgeschakeld"',
        v-model='data.enabled',
        style='max-width: 180px',
        color='primary',
        hide-details
        )

  .pa-4
    text-field.mr-0(
      label='Naam afzender',
      v-model='data.fromName',
      required,
      :error-messages='fromNameValidationErrors',
      @change='$v.data.fromName.$touch()',
      @blur='$v.data.fromName.$touch()'
      )

    v-layout(column)
      b.mb-1 Textbericht naar {{ isDealer ? 'dealer' : 'klant' }}
      v-textarea(
        solo,
        v-model='data.template',
        required,
        :error-messages='templateValidationErrors',
        @change='$v.data.template.$touch()',
        @blur='$v.data.template.$touch()',
        :counter='0',
        rows='13'
        )
      small Let op: Een SMS bevat maximaal 160 tekens per bericht. Omdat de personalisatie codes vervangen worden weet je van te voren niet hoeveel SMS berichten nodig zijn.

</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'NotificationEmail',

  components: {
    OrganizationFiles: require('./OrganizationFiles').default,
    PersonalisationPricingDialog: require('./PersonalisationPricingDialog').default
  },

  props: {
    isDealer: Boolean,
    value: Object
  },

  data () {
    return {
      data: this.value,
      dialogPricingOpen: false
    }
  },

  computed: {
    fromNameValidationErrors () {
      const errors = []
      if (!this.$v.data.fromName.$dirty) return errors
      !this.$v.data.fromName.required && errors.push('Dit veld is verplicht')
      return errors
    },

    templateValidationErrors () {
      const errors = []
      if (!this.$v.data.template.$dirty) return errors
      !this.$v.data.template.required && errors.push('Dit veld is verplicht')
      return errors
    }
  },

  validations: {
    data: {
      fromName: {
        required
      },

      template: {
        required
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
